import { action } from 'mobx';

import { ConnectionAppManager, Variables } from 'core/index';

import { CollectionArrayApp } from 'apps/collection/app';
import {
  CollectionMutation,
  ProfileCollectionsQuery,
} from 'apps/collection/gql';

import i18next from 'i18next';

export class CollectionConnManager extends ConnectionAppManager {
  static ArrayApp = CollectionArrayApp;
  constructor(parent, init, options) {
    super(parent, init, options);
    this.initialBatchSize =
      init.batchSize || this.arrayApp.cardLayout.initialBatchSize;
    this.batchSize = this.arrayApp.cardLayout.batchSize;
    this.sortBy = init.sortBy || 'recent';
    this.sortOptions = init.sortOptions || [
      ['recent', i18next.t('Recent')],
      ['name', i18next.t('Name')],
      ['-projects', i18next.t('Projects')],
    ];
    this.variables = new Variables({
      username: () => {
        if (init.profile && init.profile.username) {
          return init.profile.username;
        }
        return this.manager.variables.username;
      },
      sortBy: () => this.sortBy,
      batchSize: () => {
        if (this.loadedMore) {
          return this.batchSize;
        }
        return this.initialBatchSize;
      },
      cursor: () => this.endCursor,
    });
    this.loadMoreQuery = init.loadMoreQuery || ProfileCollectionsQuery;
    this.variables.onChange(['username'], this.NewUsername);
  }

  @action NewUsername = () => {
    this.Reset();
    if (this.loadInstantly) {
      this.loadMore();
    }
  };

  @action SetSort = sort => {
    this.sortBy = sort;
    this.Clear();
    this.loadMore();
  };

  @action MutateProjects = (input, options) => {
    this.mutations.push(CollectionMutation.New(input, options));
  };
}
